import { Injectable } from '@angular/core';
import { CommonService } from '../Services/common.service';
import { ConfigSettingService } from '../Services/config-setting.service';
import { DataManipService } from '../Services/data-manip.service';
import {DashboardComponent} from '../views/dashboard/dashboard.component' 
import { ActivatedRoute, Router } from '@angular/router';
import { EncrptDecreptService } from './encrpt-decrept.service';
@Injectable({
  providedIn: 'root'
})
export class UpdateBalanceService {
  showLoader: boolean = false;
  userName: string = "";
  gender: any = "";
  education: string = "";
  occupation: string = "";
  address: string = "";
  country: string = "";
  state: string = "";
  city: string = "";
  dob = new Date();
  age: number = null;
  prefLanguage: string = "";
  mobile: number = null;
  email: string = "";
  wallet: number = 10;
  noneditable: boolean = true;
  showUpdatedMsg: string = "";
  dobStr;
  registerby=""
  constructor(public dataManipSrvc: DataManipService, private router: Router,private encryptService: EncrptDecreptService,
    private commonServices: CommonService, private configSetting: ConfigSettingService) { }

  updateBalance(page:any){
// console.log(page)
     let userID=this.dataManipSrvc.userId;
     let apiUrl = this.configSetting.getBaseUrl() + "orderpayments/getWalletBalance";
     let param={}
     this.commonServices.postMethod(apiUrl,param).subscribe(successResp => {
  
       if(successResp['errorCode'] == "000000"){
         if(page=="profile"){
          this.commonServices.walletamount=successResp['Data'][0]['walletbalance'];
      // console.log("In Profile",this.commonServices.walletamount);
      //this.router.navigateByUrl("/myprofile");
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigate(["/myprofile"]);
    });
      
     }
    //  if(page=="dashboard"){
    //   this.router.navigateByUrl("/dashboard");
    //  }

      
    }
  });
  }

  getUserDetails() {
 
    this.showLoader = true;
    let apiUrl = this.configSetting.getBaseUrl() + "user/getUserDetailByUserId";
    let body = {
      "userid": this.encryptService.encrypt(this.dataManipSrvc.userId+"")
    }

    this.commonServices.getWithParams(apiUrl, body).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        let userData = {};
        userData = successResp["Data"][0];
        this.userName = userData["username"];
        this.gender = userData["gender"];
        this.education = userData["education"];
        this.occupation = userData["occupation"];
        this.address = userData["address"];
        this.country = userData["country"];
        this.state = userData["state"];
        this.city = userData["city"];
        this.dob = new Date(userData["dob"]);
        this.dobStr = userData["dob"];
        this.age = userData["age"];
        this.prefLanguage = userData["preflanguage"];
        this.mobile = userData["mobileno"];
        this.email = userData["emailid"];
        this.registerby=userData["registerby"]
        this.wallet = userData["walletbalance"];

      }
    })
  }

  
}
